<template>
	<transition 
			appear
			:appear-active-class="$_rctStpTabLyt_stylePageLayoutAnimation()">
		<v-row no-gutters>
			<v-col>
				<template v-if="!$_rctStpTabLyt_statePageHideTab">
					<!-- tab for mobile (dropdown) -->
					<template v-if="$_rctStpTabLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-toolbar color="transparent">
									<v-menu offset-y>
										<template v-slot:activator="{ on }">
											<v-btn	class="customVBtn"
													color="primary"
													dark
													icon
													v-on="on">
												<v-icon>
													keyboard_arrow_down
												</v-icon>
											</v-btn>
										</template>
										<v-list>
											<template v-for="(stepVals, stepKey, stepIndex) in sortObject($_rctStpTabLyt_recruitScheduleSteps, 'order')">
												<template v-if="$_rctStpTabLyt_checkStepIsOpened(stepKey)">
													<v-list-item
															:key="stepKey"
															@click="$_rctStpTabLyt_selectStep(stepVals, stepIndex)">
														<v-list-item-title
																v-html="$_rctStpTabLyt_langContentStepTitle(stepVals)" />
													</v-list-item>
												</template>
											</template>
										</v-list>
									</v-menu>
									<v-toolbar-title 
											class="subtitle-1"
											v-html="stepTitle_" />
								</v-toolbar>
							</v-col>
						</v-row>
					</template>
					<v-row no-gutters>
						<!-- tab for web (vertical) -->
						<template v-if="!$_rctStpTabLyt_stateAppIsMobileScreen">
							<v-col cols="auto">
								<v-tabs v-model="stepNumber_"
								
										class="customVTabs"
										vertical

										:background-color="$_rctStpTabLyt_styleStepTabTabsBackgroundColor"
										:color="$_rctStpTabLyt_styleStepTabTabsColor"
										:dark="$_rctStpTabLyt_styleStepTabTabsDark"
										:hide-slider="$_rctStpTabLyt_styleStepTabTabsHideSlider"
										:light="$_rctStpTabLyt_styleStepTabTabsLight"
										:slider-color="$_rctStpTabLyt_styleStepTabTabsSliderColor">
									<template v-for="(stepVals, stepKey) in sortObject($_rctStpTabLyt_recruitScheduleSteps, 'order')">
										<v-tab	:key="stepKey"

												:disabled="!$_rctStpTabLyt_checkStepIsOpened(stepKey)"

												:dark="$_rctStpTabLyt_styleTabDark"
												:light="$_rctStpTabLyt_styleTabLight">
											<span	class="caption"
													v-html="$_rctStpTabLyt_langContentStepTitle(stepVals)" />
										</v-tab>
									</template>
								</v-tabs>
							</v-col>
						</template>
						<v-spacer />
						<!-- tab content -->
						<v-col cols="11" md="8">
							<v-tabs-items
									class="customVTabs"
									v-model="stepNumber_">
								<template v-for="(stepVals, stepKey, stepIndex) in sortObject($_rctStpTabLyt_recruitScheduleSteps, 'order')">
									<v-tab-item :key="stepIndex">
										<v-row class="customVRow" no-gutters>
											<v-col>
												<template v-if="stepVals.title">
													<v-row justify="center">
														<v-col>
															<v-sheet
																	class="customVSheet"
																	pa-3 
																	:color="$_rctStpTabLyt_styleStepTabHeaderSheetColor"
																	:dark="$_rctStpTabLyt_styleStepTabHeaderSheetDark"
																	:elevation="$_rctStpTabLyt_styleStepTabHeaderSheetElevation"
																	:light="$_rctStpTabLyt_styleStepTabHeaderSheetLight">
																<v-card color="transparent" flat>
																	<v-card-text class="center">
																		<center>
																			<span	class="headline"
																					v-html="$_rctStpTabLyt_langContentTitle(stepVals)" />
																		</center>
																	</v-card-text>
																</v-card>
															</v-sheet>
														</v-col>
													</v-row>
												</template>
												<v-row>
													<v-col>
														<v-sheet
																class="customVSheet"
																:color="$_rctStpTabLyt_styleStepTabBodySheetColor"
																:dark="$_rctStpTabLyt_styleStepTabBodySheetDark"
																:elevation="$_rctStpTabLyt_styleStepTabBodySheetElevation"
																:light="$_rctStpTabLyt_styleStepTabBodySheetLight">
															<v-card	class="customVCard"
																	color="transparent"
																	flat>
																<template v-if="stepVals.bigImage">
																	<v-row>
																		<v-col>
																			<v-img	class="customVImg"
																					:src="$_rctStpTabLyt_styleContentBigImageUrl(stepVals)" />
																		</v-col>
																	</v-row>
																</template>
																<template v-if="!isEmpty(stepVals.video)">
																	<v-row>
																		<v-col>
																			<card-video
																					:contentKey="stepKey"
																					:contents="$_rctStpTabLyt_recruitScheduleSteps"
																					:inits="inits"
																					@ended="$_rctStpTabLyt_complete(stepKey)" />
																		</v-col>
																	</v-row>
																</template>
																<v-row no-gutters>
																	<template v-if="isObject(stepVals.image)">
																		<v-col cols="12" md="4" class="center">
																			<v-img	class="customVImg"
																					:src="$_rctStpTabLyt_styleContentImageUrl(stepVals)" />
																		</v-col>
																	</template>
																	<template v-if="stepVals.subTitle || stepVals.text || stepVals.actionButtons">
																		<v-col>
																			<template v-if="stepVals.subTitle">
																				<v-card-title>
																					<span v-html="$_rctStpTabLyt_langContentSubTitle(stepVals)" />
																				</v-card-title>
																			</template>
																			<template v-if="stepVals.text">
																				<v-card-text>
																					<span v-html="$_rctStpTabLyt_langContentText(stepVals)" />
																				</v-card-text>
																			</template>
																			<template v-if="stepVals.actionButtons">
																				<v-card-actions>
																					<v-row>
																						<template v-for="(actionButtonVals, actionButtonKey) in sortObject(stepVals.actionButtons, 'order')">
																							<v-col :key="actionButtonKey">
																								<v-btn	class="customVBtn"
																										:block="$_rctStpTabLyt_styleStepTabActionButtonBlock"
																										:color="$_rctStpTabLyt_styleStepTabActionButtonColor"
																										:dark="$_rctStpTabLyt_styleStepTabActionButtonDark"
																										:depressed="$_rctStpTabLyt_styleStepTabActionButtonDepressed"
																										:elevation="$_rctStpTabLyt_styleStepTabActionButtonElevation"
																										:large="$_rctStpTabLyt_styleStepTabActionButtonLarge"
																										:light="$_rctStpTabLyt_styleStepTabActionButtonLight"
																										:outlined="$_rctStpTabLyt_styleStepTabActionButtonOutlined"
																										:rounded="$_rctStpTabLyt_styleStepTabActionButtonRounded"
																										:small="$_rctStpTabLyt_styleStepTabActionButtonSmall"
																										:text="$_rctStpTabLyt_styleStepTabActionButtonFlat"
																										@click="openLink(actionButtonVals.link)"
																										v-text="$_rctStpTabLyt_langContentTitle(actionButtonVals)" />
																							</v-col>
																						</template>
																					</v-row>
																				</v-card-actions>
																			</template>
																		</v-col>
																	</template>
																</v-row>
																<v-row no-gutters>
																	<v-col>
																		<template v-if="!isEmpty(stepVals.openStep)">
																			<v-card-actions>
																				<v-btn	class="customVBtn"

																						:disabled="$_rctStpTabLyt_checkStepIsCompleted(stepKey)"

																						:block="$_rctStpTabLyt_styleStepTabOpenStepButtonBlock"
																						:color="$_rctStpTabLyt_styleStepTabOpenStepButtonColor"
																						:dark="$_rctStpTabLyt_checkStepIsPassed(stepKey) ? false : $_rctStpTabLyt_styleStepTabOpenStepButtonDark"
																						:depressed="$_rctStpTabLyt_styleStepTabOpenStepButtonDepressed"
																						:elevation="$_rctStpTabLyt_styleStepTabOpenStepButtonElevation"
																						:large="$_rctStpTabLyt_styleStepTabOpenStepButtonLarge"
																						:light="$_rctStpTabLyt_styleStepTabOpenStepButtonLight"
																						:outlined="$_rctStpTabLyt_styleStepTabOpenStepButtonOutlined"
																						:rounded="$_rctStpTabLyt_styleStepTabOpenStepButtonRounded"
																						:small="$_rctStpTabLyt_styleStepTabOpenStepButtonSmall"
																						:text="$_rctStpTabLyt_styleStepTabOpenStepButtonFlat"
																						@click="$_rctStpTabLyt_openStep(stepKey, stepVals)"
																						v-text="$_rctStpTabLyt_langContentOpenStepTitle(stepVals)" />
																			</v-card-actions>
																			<template v-if="$_rctStpTabLyt_checkStepIsCompleted(stepKey)">
																				<v-row align="center" justify="center">
																					<v-col cols="auto">
																						<span	class="caption"
																								v-html="$_rctStpTabLyt_langStepTabCompletedStep" />
																					</v-col>
																				</v-row>
																			</template>
																		</template>
																		<template v-if="!isFalse(stepVals.completeStep)">
																			<v-card-actions>
																				<v-checkbox
																						:input-value="$_rctStpTabLyt_checkStepIsCompleted(stepKey)"

																						:readonly="!isEmpty(stepVals.video)"
																						:disabled="$_rctStpTabLyt_checkStepIsCompleted(stepKey)"

																						:label="$_rctStpTabLyt_langContentCompleteStep(stepVals)"																								
																						:messages="$_rctStpTabLyt_checkStepIsCompleted(stepKey) ? $_rctStpTabLyt_langStepTabCompletedStep : []"

																						@change="$_rctStpTabLyt_complete(stepKey)" />
																			</v-card-actions>
																		</template>
																	</v-col>
																</v-row>
															</v-card>
														</v-sheet>
													</v-col>
												</v-row>
												<template v-if="$_rctStpTabLyt_checkStepIsPassed(stepKey)">
													<v-row>
														<v-col>
															<v-alert
																	class="customVAlert"
																	border="top"
																	colored-border
																	prominent
																	type="info"
																	elevation="8">
																<v-card	class="customVCard"
																		color="transparent"
																		flat>
																	<v-card-text>
																		You have passed this step.
																	</v-card-text>
																</v-card>
															</v-alert>
														</v-col>
													</v-row>
												</template>
												<template v-if="$_rctStpTabLyt_checkStepIsFailed(stepKey)">
													<v-row>
														<v-col>
															<v-alert
																	class="customVAlert"
																	border="top"
																	colored-border
																	prominent
																	type="error"
																	elevation="8">
																<v-card	class="customVCard"
																		color="transparent"
																		flat>
																	<v-card-text>
																		You have not passed this step.
																	</v-card-text>
																</v-card>
															</v-alert>
														</v-col>
													</v-row>
												</template>
												<v-row>
													<!-- previouse step -->
													<v-col cols="12" md="6">
														<v-btn	class="customVBtn"

																:disabled="!$_rctStpTabLyt_getPrevious(stepKey)"
														
																:block="$_rctStpTabLyt_styleStepTabNavigationButtonBlock"
																:color="$_rctStpTabLyt_styleStepTabNavigationButtonColor"
																:dark="$_rctStpTabLyt_getPrevious(stepKey) ? $_rctStpTabLyt_styleStepTabNavigationButtonDark : false"
																:depressed="$_rctStpTabLyt_styleStepTabNavigationButtonDepressed"
																:elevation="$_rctStpTabLyt_styleStepTabNavigationButtonElevation"
																:large="$_rctStpTabLyt_styleStepTabNavigationButtonLarge"
																:light="$_rctStpTabLyt_styleStepTabNavigationButtonLight"
																:outlined="$_rctStpTabLyt_styleStepTabNavigationButtonOutlined"
																:rounded="$_rctStpTabLyt_styleStepTabNavigationButtonRounded"
																:small="$_rctStpTabLyt_styleStepTabNavigationButtonSmall"
																:text="$_rctStpTabLyt_styleStepTabNavigationButtonFlat"
																@click="$_rctStpTabLyt_openPreviousStep(stepIndex)"
																v-text="$_rctStpTabLyt_langStepTabPreviousStep" />
													</v-col>
													<!-- back to schedule -->
													<template v-if="$_rctStpTabLyt_getLast() == stepKey">
														<v-col cols="12" md="6">
															<v-btn	class="customVBtn"

																	:disabled="!$_rctStpTabLyt_checkStepIsPassed(stepKey)"
															
																	:block="$_rctStpTabLyt_styleStepTabNavigationButtonBlock"
																	:color="$_rctStpTabLyt_styleStepTabNavigationButtonColor"
																	:dark="$_rctStpTabLyt_checkStepIsCompleted(stepKey) ? $_rctStpTabLyt_styleStepTabNavigationButtonDark : false"
																	:depressed="$_rctStpTabLyt_styleStepTabNavigationButtonDepressed"
																	:elevation="$_rctStpTabLyt_styleStepTabNavigationButtonElevation"
																	:large="$_rctStpTabLyt_styleStepTabNavigationButtonLarge"
																	:light="$_rctStpTabLyt_styleStepTabNavigationButtonLight"
																	:outlined="$_rctStpTabLyt_styleStepTabNavigationButtonOutlined"
																	:rounded="$_rctStpTabLyt_styleStepTabNavigationButtonRounded"
																	:small="$_rctStpTabLyt_styleStepTabNavigationButtonSmall"
																	:text="$_rctStpTabLyt_styleStepTabNavigationButtonFlat"
																	@click="$_rctStpTabLyt_backToRecruitment()"
																	v-text="$_rctStpTabLyt_langStepTabBackToSchedule" />
														</v-col>
													</template>
													<!-- next step -->
													<template v-else>
														<v-col cols="12" md="6">
															<v-btn	class="customVBtn"

																	:disabled="!$_rctStpTabLyt_checkStepIsOpened($_rctStpTabLyt_getNext(stepKey))"
															
																	:block="$_rctStpTabLyt_styleStepTabNavigationButtonBlock"
																	:color="$_rctStpTabLyt_styleStepTabNavigationButtonColor"
																	:dark="$_rctStpTabLyt_checkStepIsOpened($_rctStpTabLyt_getNext(stepKey)) ? $_rctStpTabLyt_styleStepTabNavigationButtonDark : false"
																	:depressed="$_rctStpTabLyt_styleStepTabNavigationButtonDepressed"
																	:elevation="$_rctStpTabLyt_styleStepTabNavigationButtonElevation"
																	:large="$_rctStpTabLyt_styleStepTabNavigationButtonLarge"
																	:light="$_rctStpTabLyt_styleStepTabNavigationButtonLight"
																	:outlined="$_rctStpTabLyt_styleStepTabNavigationButtonOutlined"
																	:rounded="$_rctStpTabLyt_styleStepTabNavigationButtonRounded"
																	:small="$_rctStpTabLyt_styleStepTabNavigationButtonSmall"
																	:text="$_rctStpTabLyt_styleStepTabNavigationButtonFlat"
																	@click="$_rctStpTabLyt_openNextStep(stepIndex)"
																	v-text="$_rctStpTabLyt_langStepTabNextStep" />
														</v-col>
													</template>
												</v-row>
											</v-col>
										</v-row>
									</v-tab-item>
								</template>
							</v-tabs-items>
						</v-col>
						<v-spacer />
					</v-row>
				</template>
				<template v-else>
					<v-row	class="customVRow">
						<v-col cols="12" class="center">
							<progress-circular />
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'RecruitStepTabLayout',
		props: {
			schedule: Object,
			
			contents: Object,
			inits: Object
		},
		data() {
			return {
				stepNumber_: 0,
				stepTitle_: ''
			}
		},
		computed: {
			// params
			$_rctStpTabLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_rctStpTabLyt_paramsRecruitmentId() {
				const self_ = this;
				const params_ = self_.$_rctStpTabLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.recruitmentId
			},
			$_rctStpTabLyt_paramsScheduleId() {
				const self_ = this;
				const params_ = self_.$_rctStpTabLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.scheduleId
			},
			// recruit
			$_rctStpTabLyt_recruitSchedule() {
				const self_ = this;
				return self_.schedule[self_.$_rctStpTabLyt_paramsScheduleId]
			},
			$_rctStpTabLyt_recruitScheduleSteps() {
				const self_ = this;
				const schedule_ = self_.$_rctStpTabLyt_recruitSchedule;
				if(self_.isEmpty(schedule_)) { return null }
				return schedule_.steps
			},
			// state
			$_rctStpTabLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_rctStpTabLyt_statePageHideTab() {
				const self_ = this;
				const page_ = self_.getPageState('recruit')
				return page_.hideTab
			},
			// (recruit)
			$_rctStpTabLyt_stateUserRecruit() {
				const self_ = this;
				const recruit_ = self_.getUserState('recruit')
				return recruit_[self_.$_rctStpTabLyt_paramsRecruitmentId]
			},
			$_rctStpTabLyt_stateUserRecruitAppliedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.appliedStep
			},
			$_rctStpTabLyt_stateUserRecruitReservedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.reservedStep
			},
			$_rctStpTabLyt_stateUserRecruitOpenedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.openedStep
			},
			$_rctStpTabLyt_stateUserRecruitCompletedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.completedStep
			},
			$_rctStpTabLyt_stateUserRecruitPassedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.passedStep
			},
			$_rctStpTabLyt_stateUserRecruitFailedStep() {
				const self_ = this;
				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.failedStep
			},
			// lang
			$_rctStpTabLyt_langStepTabOpenStepButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'stepTabOpenStepButton')
				return self_.getLangsVal(lang_)
			},
			$_rctStpTabLyt_langStepTabCompletedStep() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'stepTabCompletedStep')
				return self_.getLangsVal(lang_)
			},
			$_rctStpTabLyt_langStepTabPreviousStep() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'stepTabPreviousStep')
				return self_.getLangsVal(lang_)
			},
			$_rctStpTabLyt_langStepTabNextStep() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'stepTabNextStep')
				return self_.getLangsVal(lang_)
			},
			$_rctStpTabLyt_langStepTabBackToSchedule() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'stepTabBackToSchedule')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_rctStpTabLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const title_ = contentVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_rctStpTabLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const subTitle_ = contentVals.subTitle;
					if(self_.isFalse(subTitle_)) { return null }
					return self_.getLangsVal(subTitle_)
				}
			},
			$_rctStpTabLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const text_ = contentVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			$_rctStpTabLyt_langContentStepTitle() {
				const self_ = this;
				return contentVals => {
					const stepTitle_ = contentVals.stepTitle;
					if(self_.isFalse(stepTitle_)) { return null }
					return self_.getLangsVal(stepTitle_)
				}
			},
			$_rctStpTabLyt_langContentCompleteStep() {
				const self_ = this;
				return contentVals => {
					const completeStep_ = contentVals.completeStep;
					if(self_.isFalse(completeStep_)) { return null }
					return self_.getLangsVal(completeStep_)
				}
			},
			$_rctStpTabLyt_langContentOpenStep() {
				const self_ = this;
				return contentVals => {
					const openStep_ = contentVals.openStep;
					if(self_.isEmpty(openStep_)) { return null }
					return openStep_
				}
			},
			$_rctStpTabLyt_langContentOpenStepTitle() {
				const self_ = this;
				return contentVals => {
					const open_ = self_.$_rctStpTabLyt_langContentOpenStep(contentVals);
					if(self_.isEmpty(open_)) { return null }
					return self_.getLangsVal(open_.title)
				}
			},
			// link
			// (content)
			$_rctStpTabLyt_linkContentOpenStep() {
				const self_ = this;
				return contentVals => {
					const openStep_ = contentVals.openStep;
					if(self_.isEmpty(openStep_)) { return null }
					return openStep_.link
				}
			},
			// style
			$_rctStpTabLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_rctStpTabLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_rctStpTabLyt_stylePageLayout();
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_rctStpTabLyt_styleStepTabHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabHeaderSheet')
			},
			$_rctStpTabLyt_styleStepTabHeaderSheetColor() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_rctStpTabLyt_styleStepTabHeaderSheetDark() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_rctStpTabLyt_styleStepTabHeaderSheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_rctStpTabLyt_styleStepTabHeaderSheetLight() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_rctStpTabLyt_styleStepTabBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabBodySheet')
			},
			$_rctStpTabLyt_styleStepTabBodySheetColor() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_rctStpTabLyt_styleStepTabBodySheetDark() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_rctStpTabLyt_styleStepTabBodySheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_rctStpTabLyt_styleStepTabBodySheetLight() {
				const self_ = this;
				const sheet_ = self_.$_rctStpTabLyt_styleStepTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_rctStpTabLyt_styleStepTabActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabActionButton')
			},
			$_rctStpTabLyt_styleStepTabActionButtonBlock() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_rctStpTabLyt_styleStepTabActionButtonColor() {
				const self_ = this;
				const button_ =self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_rctStpTabLyt_styleStepTabActionButtonDark() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_rctStpTabLyt_styleStepTabActionButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_rctStpTabLyt_styleStepTabActionButtonElevation() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_rctStpTabLyt_styleStepTabActionButtonFlat() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_rctStpTabLyt_styleStepTabActionButtonLarge() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_rctStpTabLyt_styleStepTabActionButtonLight() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_rctStpTabLyt_styleStepTabActionButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_rctStpTabLyt_styleStepTabActionButtonRounded() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_rctStpTabLyt_styleStepTabActionButtonSmall() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabOpenStepButton')
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonBlock() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonColor() {
				const self_ = this;
				const button_ =self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonDark() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonElevation() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonFlat() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonLarge() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonLight() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonRounded() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_rctStpTabLyt_styleStepTabOpenStepButtonSmall() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabOpenStepButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_rctStpTabLyt_styleStepTabStartButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabStartButton')
			},
			$_rctStpTabLyt_styleStepTabStartButtonBlock() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_rctStpTabLyt_styleStepTabStartButtonColor() {
				const self_ = this;
				const button_ =self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_rctStpTabLyt_styleStepTabStartButtonDark() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_rctStpTabLyt_styleStepTabStartButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_rctStpTabLyt_styleStepTabStartButtonElevation() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_rctStpTabLyt_styleStepTabStartButtonFlat() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_rctStpTabLyt_styleStepTabStartButtonLarge() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_rctStpTabLyt_styleStepTabStartButtonLight() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_rctStpTabLyt_styleStepTabStartButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_rctStpTabLyt_styleStepTabStartButtonRounded() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_rctStpTabLyt_styleStepTabStartButtonSmall() {
				const self_ = this;
				const button_ = self_.$_rctStpTabLyt_styleStepTabStartButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_rctStpTabLyt_styleStepTabNavigationButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabNavigationButton')
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonBlock() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.block)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonColor() {
				const self_ = this;
				const navigationButton_ =self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.color)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonDark() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.dark)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonDepressed() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.depressed)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonElevation() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.elevation)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonFlat() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.flat)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonLarge() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.large)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonLight() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.light)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonOutlined() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.outlined)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonRounded() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.rounded)
			},
			$_rctStpTabLyt_styleStepTabNavigationButtonSmall() {
				const self_ = this;
				const navigationButton_ = self_.$_rctStpTabLyt_styleStepTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.small)
			},
			$_rctStpTabLyt_styleStepTabTabs() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepTabTabs')
			},
			$_rctStpTabLyt_styleStepTabTabsBackgroundColor() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.backgroundColor)
			},
			$_rctStpTabLyt_styleStepTabTabsColor() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.color)
			},
			$_rctStpTabLyt_styleStepTabTabsDark() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.dark)
			},
			$_rctStpTabLyt_styleStepTabTabsHideSlider() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.hideSlider)
			},
			$_rctStpTabLyt_styleStepTabTabsLight() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.light)
			},
			$_rctStpTabLyt_styleStepTabTabsSliderColor() {
				const self_ = this;
				const tabs_ = self_.$_rctStpTabLyt_styleStepTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.sliderColor)
			},
			$_rctStpTabLyt_styleTab() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tab')
			},
			$_rctStpTabLyt_styleTabDark() {
				const self_ = this;
				const tab_ = self_.$_rctStpTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.dark)
			},
			$_rctStpTabLyt_styleTabLight() {
				const self_ = this;
				const tab_ = self_.$_rctStpTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.light)
			},
			// (content)
			$_rctStpTabLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_rctStpTabLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_rctStpTabLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_rctStpTabLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_rctStpTabLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const bigImage_ = self_.$_rctStpTabLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(bigImage_)) { return null }
					return self_.getStylesVal(bigImage_.url)
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_rctStpTabLyt_start()
		},
		methods: {
			$_rctStpTabLyt_start() {
				const self_ = this;

				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;

				// initialize opened step
				if(self_.isFalse(recruit_.openedStep)) {
					recruit_.openedStep = {}
				}

				// initialize passed step
				if(self_.isFalse(recruit_.passedStep)) {
					recruit_.passedStep = {}
				}

				// initialize failed step
				if(self_.isFalse(recruit_.failedStep)) {
					recruit_.failedStep = {}
				}

				const steps_ = self_.$_rctStpTabLyt_recruitScheduleSteps;
				const sorted_ = self_.sortObject(steps_, 'order')

				let index_ = -1;
				let result_ = null;

				Object.keys(sorted_).forEach(key => {
					if(self_.isFalse(result_)) {
						index_++;

						// first step is not opened
						if(self_.isFalse(recruit_.openedStep[key]) && self_.isFalse(recruit_.passedStep[key]) && self_.isFalse(recruit_.failedStep[key])) {
							result_ = -1;
						}

						// step is already opened
						if(recruit_.openedStep[key] && self_.isFalse(recruit_.passedStep[key]) && self_.isFalse(recruit_.failedStep[key])) {
							result_ = index_;
						}
					}
				})

				// open last step
				if(self_.isFalse(result_)) { 
					self_.stepNumber_ = index_;
				}
				// open first step
				else if (result_ == -1) {
					const first_ = self_.$_rctStpTabLyt_getFirst()

					recruit_.openedStep[first_] = true;

					Promise.resolve().then(() => {
						return self_.$_rctStpTabLyt_updateRecruitState(recruit_)
					}).then(() => {
						self_.stepNumber_ = 0;
					})
				}
				// open step
				else {
					self_.stepNumber_ = result_;
				}
			},
			$_rctStpTabLyt_selectStep(stepVals, stepIndex) {
				const self_ = this;
				
				self_.stepNumber_ = stepIndex;
				self_.stepTitle_ = self_.getLangsVal(stepVals.title)
			},
			$_rctStpTabLyt_openStep(stepId, stepVals) {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.$_rctStpTabLyt_complete(stepId)
				}).then(() => {
					const link_ = self_.$_rctStpTabLyt_linkContentOpenStep(stepVals)
					self_.openLink(link_)
				}).catch(error => {
/* error */			self_.logError('Error', '$_rctStpTabLyt_openStep(' + stepId + ', stepVals)', error)
/* debug */			self_.logDebug('debug', 'stepVals', stepVals)
				})
			},
			$_rctStpTabLyt_openPreviousStep(index) {
				const self_ = this;
				self_.stepNumber_ = index - 1;
			},
			$_rctStpTabLyt_openNextStep(index) {
				const self_ = this;
				self_.stepNumber_ = index + 1;
			},
			$_rctStpTabLyt_backToRecruitment() {
				const self_ = this;
				const router_ = self_.$router;

				router_.push({
					name: 'recruit',
					params: {
						recruitmentId: self_.$_rctStpTabLyt_paramsRecruitmentId
					}
				})
			},
			$_rctStpTabLyt_complete(stepId) {
				const self_ = this;

				const next_ = self_.$_rctStpTabLyt_getNext(stepId)

				if(next_) {
					return self_.$_rctStpTabLyt_completeStep(stepId, next_)
				}
			},
			$_rctStpTabLyt_completeStep(currentStepId, nextStepId) {
				const self_ = this;

				const recruit_ = self_.$_rctStpTabLyt_stateUserRecruit;

				// complete this step
				recruit_.completedStep[currentStepId] = true;

				return self_.$_rctStpTabLyt_updateRecruitState(recruit_)
			},
			$_rctStpTabLyt_getFirst() {
				const self_ = this;

				const steps_ = self_.$_rctStpTabLyt_recruitScheduleSteps;
				const sorted_ = self_.sortObject(steps_, 'order')
				const keys_ = Object.keys(sorted_)

				return keys_[0]
			},
			$_rctStpTabLyt_getLast() {
				const self_ = this;

				const steps_ = self_.$_rctStpTabLyt_recruitScheduleSteps;
				const sorted_ = self_.sortObject(steps_, 'order')
				const keys_ = Object.keys(sorted_)

				return keys_[keys_.length - 1]
			},
			$_rctStpTabLyt_getNext(stepId) {
				const self_ = this;

				const steps_ = self_.$_rctStpTabLyt_recruitScheduleSteps;
				const sorted_ = self_.sortObject(steps_, 'order')

				let result_ = null;
				let next_ = false;

				Object.keys(sorted_).forEach(key => {
					if(self_.isFalse(result_)) {
						if(next_) { result_ = key }

						if(key == stepId) {
							next_ = true;
						}
					}
				})

				return result_
			},
			$_rctStpTabLyt_getPrevious(stepId) {
				const self_ = this;

				const steps_ = self_.$_rctStpTabLyt_recruitScheduleSteps;
				const sorted_ = self_.sortObject(steps_, 'order')

				let result_ = null;
				let previous_ = false;

				Object.keys(sorted_).forEach(key => {
					if(self_.isFalse(previous_)) {
						if(key == stepId) {
							previous_ = true;
						} else {
							result_ = key;
						}
					}
				})

				return result_
			},
			$_rctStpTabLyt_updateRecruitState(recruit) {
				const self_ = this;

				const recruitment_ = self_.$_rctStpTabLyt_paramsRecruitmentId;

				let page_ = self_.getPageState('recruit')

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						page_.hideTab = true;

						self_.setPageState('recruit', page_)

						return
					}).then(() => {
						return self_.setUserRecruit(recruitment_, recruit)
					}).then(() => {
						return self_.initializeUser('recruit')
					}).then(() => {
						page_.hideTab = false;
						
						self_.setPageState('recruit', page_)

						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: created() -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_rctStpTabLyt_checkStepIsOpened(stepId) {
				const self_ = this;
				
				const opened_ = self_.$_rctStpTabLyt_stateUserRecruitOpenedStep;

				if(self_.isEmpty(opened_)) { return false }

				if(self_.isFalse(opened_[stepId])) { return false }
				else { return true }
			},
			$_rctStpTabLyt_checkStepIsCompleted(stepId) {
				const self_ = this;
				
				const completed_ = self_.$_rctStpTabLyt_stateUserRecruitCompletedStep;

				if(self_.isEmpty(completed_)) { return false }

				if(self_.isFalse(completed_[stepId])) { return false }
				else { return true }
			},
			$_rctStpTabLyt_checkStepIsPassed(stepId) {
				const self_ = this;
				
				const passed_ = self_.$_rctStpTabLyt_stateUserRecruitPassedStep;

				if(self_.isEmpty(passed_)) { return false }

				if(self_.isFalse(passed_[stepId])) { return false }
				else { return true }
			},
			$_rctStpTabLyt_checkStepIsFailed(stepId) {
				const self_ = this;
				
				const failed_ = self_.$_rctStpTabLyt_stateUserRecruitFailedStep;

				if(self_.isEmpty(failed_)) { return false }

				if(self_.isFalse(failed_[stepId])) { return false }
				else { return true }
			}
		}
	}
</script>

<style scoped>
	.row_ {
		height: 100%;
	}
</style>